import {
    isValidAlfaPhone,
    validateAlfaPhone,
} from '@alfa-bank/site-helpers-form/validation/alfa-phone';
import { composeValidators, validate } from '@alfa-bank/site-helpers-form/validation/utils';
import { DEFAULT_PHONE_MESSAGE } from '@alfa-bank/site-helpers-form/src/validation/phone';

import type { TFormats, ICustomValidate } from './models';

const brackets = '()';

const phoneFormatsMap: Record<TFormats, string> = {
    noBrackets: brackets,
    onlyNumbers: `${brackets}+-\\s`,
};

const getCustomValidators = (customValidates: ICustomValidate[]) => {
    return customValidates.map(customValidate => (value: string) => {
        const { regExp, textError } = customValidate;
        const isValidate = new RegExp(regExp).test(value);

        return validate(isValidate, textError);
    });
};

const validateAlfaPhoneValue = (value: string) =>
    validate(isValidAlfaPhone(value), DEFAULT_PHONE_MESSAGE);

/**
 * Форматирует значение телефона по указанным форматам§
 *
 * @param value - значение телефона
 * @param formats - массив форматов
 */
export const formatPhoneValue = (value: string, formats: TFormats[]) =>
    formats.reduce((result, format) => {
        const regexp = new RegExp(`[${phoneFormatsMap[format]}]`, 'g');

        return result.replace(regexp, '');
    }, value);

/**
 * Валидация телефона
 *
 * @param isRequired - обязательность поля
 * @param customValidates - правила для кастомной валидации
 */
export const validatePhone =
    (isRequired = true, customValidates?: ICustomValidate[]) =>
    (value: string) => {
        const needValidate = value || (!value && isRequired);

        if (needValidate) {
            if (customValidates) {
                return composeValidators(
                    validateAlfaPhoneValue,
                    ...getCustomValidators(customValidates)
                )(value);
            }

            return validateAlfaPhone()(value);
        }

        return undefined;
    };
